module.exports = __webpack_public_path__ + "img/excl.0b1d44b5.svg";